/**
 * Drawer for cart extended from generic drawer element
 */

import Drawer from './drawer';

class DrawerSearch extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.Search = this.querySelector('w3-search[data-search-drawer]');
        this.Megamenu = document.querySelector('w3-megamenu');
        this.MobileMenu = document.querySelector("w3-navigation-mobile w3-drawer");
    }

    openDrawer() {
        if (this.Megamenu.isMegamenuShow) {
            this.Megamenu.hideMegamenu();
        }

        if (this.MobileMenu?.classList.contains("drawer--visible")) {
            this.MobileMenu?.classList.remove("drawer--visible")
            this.showSearchDrawer()
            return;
        }

        this.showSearchDrawer()
    }

    showSearchDrawer() {
        this.Search.initSearch();
        super.openDrawer()
        if (!this.classList.contains("drawer--visible")) {
            this.classList.add("drawer--visible")
            this.style.display = "initial";
        }
    }

    closeDrawer() {
        super.closeDrawer()
    }
}

customElements.define('w3-drawer-search', DrawerSearch);